<template>
  <b-input-group-append @click="$emit('click')">
    <span :class="`input-group-text vis password-eye ${state ? 'hidden' : ''}`">
      <i class="fad fax fa-eye-slash fa-lg"></i>
    </span>
    <span :class="`input-group-text vis password-eye ${!state ? 'hidden' : ''}`">
      <i class="fad fax fa-eye fa-lg"></i>
    </span>
  </b-input-group-append>
</template>
<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    }
  }
}
</script>